import{combineReducers}from'redux';import menusById from"./menusById";export default combineReducers({menusById:menusById});